//#region Components
import CustomTableList from "components/CustomTableList/CustomTableList";
import TableListItem from "./TableListItem/TableListItem";
//#endregion
//#region Utils
import { HEADERS_TABLE_LIST } from "./constants";
import { Container } from "./styles";
import { useEffect, useState } from "react";
import { RESOURCE_MODULE_IDS, RESOURCES_CONSTANTS } from "config/constants";
//#endregion

const HistoryTable = ({
    campusSpaceId, 
    reasonForPenalizeId,
    changeHistory
}) => {
    const [headers, setHeaders] = useState([]);
    useEffect(() => {
        setHeaders(getHeaders());
    });
    const getHeaders = () => {
        switch (campusSpaceId) {
            case RESOURCE_MODULE_IDS.LIBRARY:
                if (reasonForPenalizeId === RESOURCES_CONSTANTS.REASON_FOR_PENALIZE_IDS.NO_REFUND)
                    return HEADERS_TABLE_LIST.LIBRARY;
                return HEADERS_TABLE_LIST.LIBRARY_WITH_PENALIZE_DAYS;
            case RESOURCE_MODULE_IDS.UNIVERSITY_SPACES:
                return HEADERS_TABLE_LIST.SPORTS_CENTER;
        }
    }
    return (
        <Container>
            <CustomTableList 
                minWidth="600px" 
                maxHeight="38vh"
                scrollColor="secondary"
                variant="secondary"
                headers={headers}>
                {changeHistory?.map((item, idx) => (
                    <TableListItem 
                        key={idx} 
                        {...item}/>
                ))}
            </CustomTableList>
        </Container>
    );
}

export default HistoryTable;